import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { ArrowRightLeft, Loader2, X } from "lucide-react";

const STATUS = {
  sendt: { label: "Leverandørskifte sendt", cls: "text-emerald-400" },
  feilet: { label: "Leverandørskifte feilet", cls: "text-red-400" },
};

export const SupplierSwitchButton = ({ mp }) => {
  const [open, setOpen] = useState(false);
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [busy, setBusy] = useState(false);
  const [state, setState] = useState({ status: mp.supplier_switch_status, fault: mp.supplier_switch_error });

  const send = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/metering-points/${mp.id}/elhub/switch`, { date });
      setState({ status: data.status, fault: data.fault });
      data.ok ? toast.success("Leverandørskifte sendt til Elhub") : toast.error(`Elhub avviste: ${data.fault || data.http_status}`);
      setOpen(false);
    } catch (e) { toast.error(e?.response?.data?.detail || "Klarte ikke å sende"); }
    finally { setBusy(false); }
  };

  const s = STATUS[state.status];
  return (
    <div className="relative flex flex-col items-start gap-1">
      <button onClick={() => setOpen(!open)} data-testid={`switch-btn-${mp.mpid}`}
        className="h-8 px-3 rounded-md border border-emerald-500/30 hover:bg-emerald-500/10 text-emerald-400 text-xs font-medium flex items-center gap-1.5 whitespace-nowrap transition-colors">
        <ArrowRightLeft className="h-3.5 w-3.5" /> Start leverandørskifte
      </button>
      {s && <span className={`text-[11px] ${s.cls}`} title={state.fault || ""} data-testid={`switch-status-${mp.mpid}`}>{s.label}</span>}
      {open && (
        <div className="absolute right-0 top-9 z-30 w-64 p-3 rounded-lg border border-zinc-800 bg-[#0b0b0b] shadow-xl space-y-2" data-testid={`switch-popover-${mp.mpid}`}>
          <div className="flex items-center justify-between text-xs text-zinc-300">
            BRS-NO-101 til Elhub
            <button onClick={() => setOpen(false)} className="text-zinc-500 hover:text-zinc-200"><X className="h-3.5 w-3.5" /></button>
          </div>
          <label className="block text-[11px] uppercase tracking-wider text-zinc-500">Ønsket startdato</label>
          <input type="date" value={date} onChange={(e) => setDate(e.target.value)} data-testid={`switch-date-${mp.mpid}`}
            className="w-full h-8 px-2 rounded-md bg-zinc-950 border border-zinc-800 text-xs text-zinc-200" />
          <button onClick={send} disabled={busy || !date} data-testid={`switch-confirm-${mp.mpid}`}
            className="w-full h-8 rounded-md bg-emerald-500 hover:bg-emerald-400 disabled:opacity-40 text-black text-xs font-medium flex items-center justify-center gap-1.5">
            {busy && <Loader2 className="h-3.5 w-3.5 animate-spin" />} Send til Elhub
          </button>
        </div>
      )}
    </div>
  );
};
